import { Route } from "./shared/route";
import { PurchaseWithTerminal } from "./terminal-purchase/purchase-with-terminal";
import { PurchaseWithVirtualTerminal } from "./terminal-purchase/purchase-with-virtual-terminal";

export default Route(
	{
		query: "Terminal_purchase",
		interactive: (query) => query.unattended !== true,
	},
	function (request) {
		if (request.query.virtualTerminal) {
			return <PurchaseWithVirtualTerminal request={request} />;
		}
		return <PurchaseWithTerminal request={request} />;
	},
);
